import MultiSignaturePreview from '../MultiSignaturePreview'
import Card from 'components/playbook/components/Card'
import UserSelect from 'components/UserSelect'

import './style.styl'


const SignaturePreview = ({
  selectedUserId,
  onUserSelect,
  selectRandomUser,
  signaturePreviewAllData,
  signaturePreviewAllFetchPending,
  signaturePreviewAllFetchFailed,
  onRefetchPreviewClick
}) => (
  <div>
    <Card title="Preview Team Signatures">
      <div className="signature-preview-user-select-wrapper">
        <h4>Choose a user to preview or select a <a onClick={selectRandomUser}>random user</a></h4>
        <div className="signature-preview-user-select-container">
          <UserSelect className="signature-preview-user-select" selectedUserId={selectedUserId} onUserIdChange={onUserSelect} />
        </div>
      </div>
      <MultiSignaturePreview
        multiSignature={signaturePreviewAllData}
        multiSignaturePreviewFetchPending={signaturePreviewAllFetchPending}
        multiSignaturePreviewFetchFailed={signaturePreviewAllFetchFailed}
        onRefetchClick={onRefetchPreviewClick}
      />
    </Card>
  </div>
)


export default SignaturePreview



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SignaturePreview/component.js